import * as StackTrace from 'stacktrace-js';

import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any) {
    const location = this.injector.get(LocationStrategy);

    const message = error.message ? error.message : error.toString();

    const url = location instanceof PathLocationStrategy ? location.path() : '';

    if (error instanceof Error) {
      StackTrace.fromError(error).then((stackframes: any) => {
        const stackString = stackframes
          .splice(0, 20)
          .map((sf: any) => {
            return sf.toString();
          })
          .join('\n');

        console.error('Error --->', { message, url, stack: stackString });
      });
    }

    throw error;
  }
}
